import { routes, permissions } from 'config/config';
import { Ability } from 'hooks/useAuth';

export interface NavigationItems {
  labelId: string;
  url: string;
  icon: string;
  badgeCount?: number;
  ability?: Ability;
  adminOnly?: boolean;
  requiresWholesaleContract?: boolean;
}

export const menuItems: NavigationItems[] = [
  {
    labelId: 'navigation.beginning',
    url: routes.admin.beginning,
    icon: 'admin/admin-navigation-home',
  },
  {
    labelId: 'navigation.company_info',
    url: routes.admin.adminBusiness,
    icon: 'admin/business',
    ability: permissions.view_company,
  },
  {
    labelId: 'navigation.transactions',
    url: routes.admin.farmTransactions,
    icon: 'admin/transactions',
    ability: permissions.view_transaction,
  },
  {
    labelId: 'navigation.contracts',
    url: routes.admin.farmContracts,
    icon: 'admin/contracts',
    ability: permissions.view_contract,
  },
  {
    labelId: 'navigation.deliveries',
    url: routes.admin.adminPartnerDeliveries,
    icon: 'admin/deliveries',
    ability: permissions.view_delivery,
  },
  {
    labelId: 'navigation.products',
    url: routes.admin.products,
    icon: 'admin/products',
    ability: permissions.view_product,
  },
  {
    labelId: 'navigation.coupons',
    url: routes.admin.coupons,
    icon: 'admin/coupons',
    ability: permissions.view_coupon,
  },
  {
    labelId: 'navigation.quality_marks',
    url: routes.admin.quality_marks,
    icon: 'admin/quality_marks',
    ability: permissions.view_quality_mark,
  },
  {
    labelId: 'navigation.partners',
    url: routes.admin.partners,
    icon: 'admin/partners',
    ability: permissions.view_partner,
  },
  {
    labelId: 'navigation.listings',
    url: routes.admin.listings,
    icon: 'admin/listings',
    ability: permissions.view_farm_listing,
    requiresWholesaleContract: true,
  },
  {
    labelId: 'navigation.chat',
    url: routes.admin.chat,
    icon: 'admin/chat',
    ability: permissions.view_partner,
  },
  {
    labelId: 'navigation.users',
    url: routes.admin.farmUsers,
    icon: 'admin/users',
    ability: permissions.view_farm_user,
  },
];

export const menuItemsAdmin: NavigationItems[] = [
  {
    labelId: 'navigation.transactions',
    url: routes.admin.transactions,
    icon: 'admin/default-admin-icon',
  },
  {
    labelId: 'navigation.e_shop_email',
    url: routes.admin.eShopEmail,
    icon: 'admin/default-admin-icon',
  },
  {
    labelId: 'navigation.farm_email',
    url: routes.admin.farmEmail,
    icon: 'admin/default-admin-icon',
  },
  {
    labelId: 'navigation.qmark',
    url: routes.admin.qmark,
    icon: 'admin/default-admin-icon',
  },
  {
    labelId: 'navigation.users',
    url: routes.admin.users,
    icon: 'admin/default-admin-icon',
  },
  {
    labelId: 'navigation.farms',
    url: routes.admin.farms,
    icon: 'admin/default-admin-icon',
  },
  {
    labelId: 'navigation.orders',
    url: routes.admin.orders,
    icon: 'admin/default-admin-icon',
  },
  {
    labelId: 'navigation.contracts',
    url: routes.admin.contracts,
    icon: 'admin/default-admin-icon',
  },
  {
    labelId: 'navigation.roles',
    url: routes.admin.roles,
    icon: 'admin/default-admin-icon',
  },
  {
    labelId: 'navigation.banners',
    url: routes.admin.banners,
    icon: 'admin/default-admin-icon',
  },
  {
    labelId: 'navigation.global_settings',
    url: routes.admin.globalSettings,
    icon: 'admin/default-admin-icon',
  },
  {
    labelId: 'navigation.catalog_settings',
    url: routes.admin.catalogSettings,
    icon: 'admin/default-admin-icon',
  },
  {
    labelId: 'navigation.emarket_settings',
    url: routes.admin.emarketSettings,
    icon: 'admin/default-admin-icon',
  },
  {
    labelId: 'navigation.page',
    url: routes.admin.page,
    icon: 'admin/default-admin-icon',
  },
  {
    labelId: 'navigation.classifiers',
    icon: 'admin/default-admin-icon',
    url: routes.admin.classifiers,
  },
  {
    labelId: 'navigation.notifications',
    icon: 'admin/notifications',
    url: routes.admin.notifications,
    adminOnly: false,
  },
];
